import {Component, OnDestroy, OnInit, Inject, Output, EventEmitter} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SafeHtml } from '@angular/platform-browser';
import {Subject} from 'rxjs';

export interface ErrorDialogData {
  title: string;
  buttonType?: string;
}

@Component({
    selector: 'app-error-dialog',
    templateUrl: './error-dialog.component.html',
    styleUrls: [],
    standalone: false
})
export class ErrorDialogComponent implements OnInit, OnDestroy {
    acceptClose: Subject<boolean> = new Subject();
    htmlContent: SafeHtml;

    constructor(public dialogRef: MatDialogRef<ErrorDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ErrorDialogData) {}

    ngOnInit() { }

    ngOnDestroy() { }

    confirmAction(boolean: boolean) {
        this.acceptClose.next(boolean);
    }

}
